// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0a91f3b8] .contactUs a{text-align:left;padding:5px 15px;border:1px solid #ddd;border-radius:24px;display:flex;justify-content:space-between;text-decoration:none}[data-v-0a91f3b8] .contactUs a:focus,[data-v-0a91f3b8] .contactUs a:hover{background-color:#eaeaea}", ""]);
// Exports
module.exports = exports;
